import { useSelector } from 'react-redux'

export default function usePlayerSeat(tempTableId, position) {
    const playerData = useSelector((state) => state.gameTable.games[tempTableId]?.playerData.find((player) => player.position === position));

    if (!playerData) {
        return {}
    }

    return playerData
}
